import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import HtmlStyles from 'styles/mixins/Html.styles';
import utils from 'helpers/utils';

const StyledMarkdown = styled.div
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--markdown-color': props.theme.property(`palette.${props.$color}`)?.main ?? props.theme.property(`palette.${props.$color}`)
    };

    return utils.styleProps(attr, vars);
  })`
  
  &.Markdown-color {
    color: ${props => props.$css.$var('--markdown-color')};
  }
  
  ${HtmlStyles}
  ${ComponentStyles}
`;

StyledMarkdown.propTypes = {
  theme: PropTypes.object
};

export default StyledMarkdown;
